module.exports = __webpack_public_path__ + "assets/img/pexels-christina-morillo-1181438-1920.d9cdd972.webp";